import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Print } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useAuth } from "hooks";
import AppTableForPrint from "components/Shared/AppTable/AppTableForPrint";
import { useCodTransferDetailContext } from "contexts/PaymentContexts/CodTransferContext";
import { usePrintCodTransferEBillMutation } from "store/services/PaymentsApi/codTransferApi";

const CodTransferEBillTab = () => {
  const { isAccountAdmin } = useAuth();
  const { CodTransferDetail } = useCodTransferDetailContext();
  const [printEBill, { isLoading }] = usePrintCodTransferEBillMutation();

  const handleDownload = async () => {
    try {
      const result = await printEBill(CodTransferDetail._id).unwrap();
      if (!result?.eBillPrintUrl) throw new Error("No download URL returned");
      window.open(result.eBillPrintUrl, "_blank", "noopener,noreferrer");
    } catch (error) {
      toast.error(error?.data?.message || error.message || "Download failed");
    }
  };

  const columns = [
    {
      name: "eBill ID",
      selector: () => CodTransferDetail?.eBillId || "N/A",
      cell: () => CodTransferDetail?.eBillId || "N/A",
      minWidth: "220px",
    },
    {
      name: "Invoice No",
      selector: () => CodTransferDetail?.eBillInvoiceNo || "N/A",
      cell: () => CodTransferDetail?.eBillInvoiceNo || "N/A",
      minWidth: "180px",
    },
    {
      name: "Amount",
      selector: () => CodTransferDetail?.feeAmount || 0,
      cell: () => Number(CodTransferDetail?.feeAmount || 0).toFixed(2),
      minWidth: "120px",
    },
    {
      name: "Action",
      cell: () =>
        isAccountAdmin ? (
          <IconButton
            size="small"
            aria-label="Download eBill"
            onClick={handleDownload}
            disabled={isLoading || !CodTransferDetail?.eBillId}
          >
            <Print color="primary" />
          </IconButton>
        ) : null,
      ignoreRowClick: true,
      right: true,
      minWidth: "120px",
    },
  ];

  return (
    <Box px={2} py={2}>
      <AppTableForPrint
        columns={columns}
        data={CodTransferDetail?.eBillId ? [CodTransferDetail] : []}
      />
      {!CodTransferDetail?.eBillId && (
        <Typography color="text.secondary" align="center" py={3}>
          No eBill details available
        </Typography>
      )}
    </Box>
  );
};

export default CodTransferEBillTab;
